import { reducerRegistry } from '../../reducer-registry'

const { createSlice } = require('@reduxjs/toolkit')

const slice = createSlice({
  name: 'stickyFooter',
  initialState: { visible: false },
  reducers: {
    setStickyFooterVisible: (state, { payload }) => {
      state.visible = payload
    },
  }
})

reducerRegistry.add('stickyFooter', slice.reducer)

export const {
  actions: { setStickyFooterVisible }
} = slice

export const isStickyFooterVisibleSelector = (state) => state.stickyFooter.visible
